var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 1772",
    xmlns: "http://www.w3.org/2000/svg",
    width: "53.22px",
    height: "53.22px",
    viewBox: "0 0 41.909 35.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1721",
    fill: "none",
    d: "M0 0H41.909V35.686H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1771",
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4285",
    d: "M30.193 30.193h-5.251V21.97c0-1.961-.034-4.485-2.73-4.485-2.735 0-3.153 2.136-3.153 4.342v8.365h-5.251V13.283h5.041v2.311h.071a5.524 5.524 0 014.973-2.731c5.322 0 6.3 3.5 6.3 8.054zM7.884 10.972a3.047 3.047 0 113.046-3.048 3.047 3.047 0 01-3.046 3.048m2.625 19.221H5.253v-16.91h5.256zM32.811 0H2.615A2.586 2.586 0 000 2.556v30.322a2.587 2.587 0 002.615 2.557h30.2a2.593 2.593 0 002.625-2.557V2.554A2.591 2.591 0 0032.811 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.3728e4141e81a655e033101ea65b60e8.svg";
export { ForwardRef as ReactComponent };